import { Link } from "react-router-dom"
import { useState } from "react"
import { Box } from "@mui/material"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Tip from "../Tools/Tip";
import { txt } from "../../services/translation";

export default function Options({post, onDelete}){

    const [showOptions, setShowOptions] = useState(false)

    return <Box>

        <Tip 
            type={showOptions ? 'close' : 'options'} 
            title={false} 
            onClick={() => setShowOptions(!showOptions)}
        />

        {showOptions &&

            <div className='social-post-options-container'>
                <div className='social-post-options'>

                    <Link to={`/community/posts/${post.id}/edit`}>
                        <div className='social-post-option'>
                            <EditIcon size='small'/>
                            <span>{txt('edit')}</span>
                        </div>
                    </Link>

                    <div className='social-post-option' onClick={onDelete}>
                        <DeleteIcon size='small'/>
                        <span>{txt('delete')}</span>
                    </div>

                </div>
            </div>
        }
        
    </Box>
}